import React from 'react';
import { useCarouselStore } from '../carousel/CarouselStore';
import { Item, ItemDefinition, registry } from '../Item';
import { CAROUSEL_BACK } from '../itemIds';

import audioEffect from '~/assets/mp3/light_switches.mp3';
import flipEffect from '~/assets/mp3/card_flip.mp3';
import { TrainingState, useTrainingStore } from '~/training/state';
import { select } from '~/lib/select';
import { CloseButton } from '~/ui/buttons/CloseButton';

const selector = (s: TrainingState) => select(s, 'auditoryFeedback');

const cardFlipAudioEffect = new Audio(flipEffect);
const audio = new Audio(audioEffect);
cardFlipAudioEffect.load();
audio.load();

export type CarouselBacktDefinition = ItemDefinition<
  typeof CAROUSEL_BACK,
  void
>;

export class CarouselBack extends Item<typeof CAROUSEL_BACK, void> {
  protected render() {
    const { prev, variant } = useCarouselStore();
    const { auditoryFeedback } = useTrainingStore(selector);

    const onClick = () => {
      if (auditoryFeedback) {
        audio.play().catch(() => {
          // Silently ignore autoplay restrictions
        });
        cardFlipAudioEffect.play().catch(() => {
          // Silently ignore autoplay restrictions
        });
      }

      prev();
    };

    if (variant === 'grid' || variant === 'dynamic') return null;

    return <CloseButton ariaLabel={'back'} onClick={onClick} />;
  }
}

registry[CAROUSEL_BACK] = CarouselBack;
